import { i18n } from "@lingui/core";
import React from 'react';
import $switchCaseDefault from 'dolla-switch';
import * as Bento from '@prezi/bento';
import { UnifiedPrivacy } from '@prezi/presentation-service-client';
import { useRTL } from '@prezi/common-components';
import { createDataLookup, TOOLTIP_ROOT } from '../../const';
import { useConfig } from '../../../utils/config';
import { useBooleanRateLimited, useEffectOnTrueLogPaywall } from '../../../hooks';
import { Tooltip } from './';
import { localI18n } from '../../../i18n';
const uxCopy = {
  openAccess: localI18n._("Anyone with the link can view"),
  closedAccess: localI18n._("Only individuals can access")
};
const getTooltipUxCopy = reason => $switchCaseDefault(reason, {
  notAllowedShared: () => ({
    title: i18n._("Not allowed to change"),
    body: i18n._("Only the owner of the document is allowed to set privacy")
  }),
  notAllowedWithCurrentLicense: () => ({
    title: i18n._("Privacy control"),
    body: i18n._("Enjoy complete control over who sees your presentations with a Standard, Plus, or Premium license."),
    action: i18n._("Upgrade")
  }),
  notAllowedWithActiveViewLinks: () => ({
    title: i18n._("Not allowed to change"),
    body: i18n._("Your document has trackable links, please remove to change access level to \"Only individuals can access\"")
  }),
  notAllowedInOrg: () => ({
    title: i18n._("Not allowed to change"),
    body: i18n._("Changing privacy is disabled for your team")
  })
}, () => {
  throw `Invalid component state: ${reason}`;
});
export const ViewLinkPrivacyDropdown = ({
  controlContext,
  unifiedPrivacy,
  onPrivacyChange
}) => {
  const {
    onUpgrade
  } = useConfig();
  const {
    isRTL
  } = useRTL();
  const dropDownRef = React.useRef(null);
  const [currentPrivacy, setCurrentPrivacy] = React.useState(unifiedPrivacy);
  const [isTooltipOpen, setIsTooltipOpen] = useBooleanRateLimited();
  useEffectOnTrueLogPaywall(isTooltipOpen, controlContext.paywall);
  return React.createElement("div", {
    ref: dropDownRef,
    onMouseEnter: () => setIsTooltipOpen(true),
    onMouseLeave: () => setIsTooltipOpen(false)
  }, React.createElement(Bento.DropdownSelect, {
    value: currentPrivacy,
    options: [{
      label: uxCopy.closedAccess,
      value: UnifiedPrivacy.unified_privacy.CLOSED
    }, {
      label: uxCopy.openAccess,
      value: UnifiedPrivacy.unified_privacy.OPEN
    }],
    disabled: controlContext.disabled,
    onChange: privacy => {
      onPrivacyChange(privacy, currentPrivacy);
      setCurrentPrivacy(privacy);
    },
    dataLookup: createDataLookup('view-link-privacy-dropdown'),
    align: isRTL ? 'left' : 'right',
    outline: false,
    backgroundColor: "#F5F5F5",
    portalRoot: TOOLTIP_ROOT,
    fitItems: true
  }), controlContext.paywall && React.createElement(Tooltip, {
    uxCopy: getTooltipUxCopy(controlContext.paywall.reason),
    onAction: () => onUpgrade('pitch_privacy_private'),
    isOpen: isTooltipOpen,
    triggerRef: dropDownRef
  }), controlContext.reason && React.createElement(Tooltip, {
    isOpen: isTooltipOpen,
    triggerRef: dropDownRef,
    uxCopy: getTooltipUxCopy(controlContext.reason)
  }));
};
export default ViewLinkPrivacyDropdown;